import { isApiError } from '../lib/apiClient';

export function Loading() {
  return (
    <div className="center-screen">
      <div className="spinner" />
    </div>
  );
}

export function PageError({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry?: () => void;
}) {
  return (
    <div className="card">
      <p className="error-text" style={{ marginTop: 0 }}>
        {isApiError(error) ? error.message : 'Something went wrong.'}
      </p>
      {onRetry && (
        <button className="btn btn--ghost" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}

export function EmptyState({ text }: { text: string }) {
  return (
    <div className="card">
      <p className="muted" style={{ margin: 0 }}>
        {text}
      </p>
    </div>
  );
}
